import React from 'react';
import { SETTINGS_TABS, TabId } from './SettingsTabs';

interface SidebarProps {
  activeTab: TabId;
  onTabChange: (tabId: TabId) => void;
}

export const SettingsSidebar = ({ activeTab, onTabChange }: SidebarProps) => {
  return (
    <aside className="w-full md:w-64 space-y-2">
      {SETTINGS_TABS.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`w-full text-left p-3 rounded-lg flex items-center gap-3 transition ${
            activeTab === tab.id ? "bg-primary text-white shadow-md" : "hover:bg-gray-100 text-gray-700"
          }`}
        >
          <span>{tab.icon}</span>
          <span className="font-medium">{tab.label}</span>
        </button>
      ))}
    </aside>
  );
};